module.exports = __webpack_public_path__ + "static/assets/img/remote_events_f.f3bcdb69.svg";